import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getModeFromPathname } from "../utils/appModeFromPath";
import { getLockedAppMode } from "../utils/lockedAppMode";

/**
 * Active app mode: locked wins when this build serves one product only,
 * else URL wins when the path implies business or developer.
 *
 * @example
 * // On /business/action-items with selectedMode "developer" in storage
 * useEffectiveAppMode();
 * // "business"
 *
 * @example
 * // REACT_APP_PRODUCTS=dataeng, on /business/action-items
 * useEffectiveAppMode();
 * // "developer"
 */
export const useEffectiveAppMode = () => {
  const { pathname, search } = useLocation();
  const { selectedMode } = useAuth();
  const lockedMode = getLockedAppMode();
  if (lockedMode) {
    return lockedMode;
  }
  return getModeFromPathname(pathname, search) ?? selectedMode;
};
